import apiInstance from "./axios";
import {
  booking,
  booking_refund,
  booking_refund_list,
  cancel_job,
  booking_accept_or_reject_job,
  booking_create_otp,
  booking_verify_otp,
  booking_get_otp,
} from "utils/services/api/schemas";

const bookingApi = {
  getBooking: async (bookingId) => {
    const response = await apiInstance.get(`${booking}/${bookingId}`);
    return response;
  },

  getBookingList: async (params) => {
    const response = await apiInstance.get(booking, { params });
    return response;
  },

  createBooking: async (data) => {
    const response = await apiInstance.post(booking, data);
    return response;
  },

  updateBooking: async (bookingId, data) => {
    const response = await apiInstance.put(`${booking}/${bookingId}`, data);
    return response;
  },

  getRefundList: async (params) => {
    const response = await apiInstance.get(booking_refund_list, { params });
    return response;
  },

  createRefund: async (data) => {
    const response = await apiInstance.post(booking_refund, data);
    return response;
  },
  cancelJob: async (data) => {
    const response = await apiInstance.post(cancel_job, data);
    return response;
  },
  deleteHistory: async (data) => {
    const response = await apiInstance.delete(booking, { data });
    return response;
  },
  acceptORRejectBooking: async (bookingId, data) => {
    const response = await apiInstance.put(
      `${booking_accept_or_reject_job}/${bookingId}`,
      data
    );
    return response;
  },
  createCaddyChallenge: async (bookingId, payload, isFormData) => {
    const response = await apiInstance.post(
      `${booking_create_otp}`,
      payload,
      isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {}
    );
    return response;
  },

  verifyCaddy: async (payload, isFormData) => {
    const response = await apiInstance.post(
      `${booking_verify_otp}`,
      payload,
      isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {}
    );
    return response;
  },
  getCaddyChallenge: async (bookingId, params) => {
    const response = await apiInstance.get(`${booking_get_otp}/${bookingId}`, {
      params,
    });
    return response;
  },
};

export default bookingApi;
